function LogoAlt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={50} height={46} viewBox="0 0 50 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M50 26.243L0 24.35V9.406l50-1.892v18.729z" fill="#FFBF17" />
      <path
        d="M34.675 26.679a13.836 13.836 0 01-9.807 4.057 13.846 13.846 0 01-10.522-4.826l-3.909-.148c.32.516.665 1.013 1.036 1.49L24.455 46 38.32 27.178c.088-.116.173-.234.258-.352l-3.903-.147z"
        fill="url(#prefix__paint0_linear_14648_26772)"
      />
      <path
        d="M14.346 7.9a13.846 13.846 0 0110.522-4.827c3.83 0 7.298 1.55 9.808 4.058l3.907-.148C35.502 2.752 30.507 0 24.868 0c-6.1 0-11.445 3.219-14.43 8.048l3.908-.148z"
        fill="url(#prefix__paint1_linear_14648_26772)"
      />
      <g filter="url(#prefix__filter0_d_14648_26772)">
        <path
          d="M6.23 18.088v1.586H4.983c-1.164 0-1.871-.71-1.871-1.879v-1.984h-.964v-.423l2.359-2.508h.372v1.537H6.2v1.394H4.925v1.673c0 .377.227.604.61.604h.695z"
          fill="#F2F2F2"
        />
      </g>
      <g filter="url(#prefix__filter1_d_14648_26772)">
        <path
          d="M10.93 17.052c0-.682-.499-1.195-1.178-1.195-.683 0-1.178.513-1.178 1.195 0 .686.499 1.199 1.178 1.199.679 0 1.178-.513 1.178-1.199zm1.724-2.633v5.258h-1.401l-.155-.372c-.431.349-.977.55-1.588.55-1.61 0-2.76-1.173-2.76-2.807 0-1.628 1.15-2.787 2.76-2.787.62 0 1.173.207 1.608.565l.185-.407h1.351z"
          fill="#F2F2F2"
        />
      </g>
      <g filter="url(#prefix__filter2_d_14648_26772)">
        <path
          d="M17.831 17.061c0-.69-.499-1.203-1.178-1.203-.679 0-1.178.513-1.178 1.203 0 .691.5 1.204 1.178 1.204.675 0 1.178-.513 1.178-1.204zm1.824 0c0 1.639-1.15 2.807-2.76 2.807-.475 0-.911-.125-1.282-.349v2.07H13.82v-7.156h1.233l.227.418c.433-.374.99-.59 1.615-.59 1.61 0 2.76 1.163 2.76 2.8z"
          fill="#F2F2F2"
        />
      </g>
      <path
        d="M22.588 19.862c-1.434 0-2.306-.756-2.322-1.895h1.745c0 .384.267.561.611.561.265 0 .517-.135.517-.407 0-.303-.399-.39-.904-.473-.816-.132-1.898-.378-1.898-1.653 0-1.054.899-1.734 2.247-1.734 1.34 0 2.209.712 2.23 1.777h-1.698c0-.335-.226-.492-.554-.492-.29 0-.486.144-.486.388 0 .299.402.369.902.458.832.147 1.937.32 1.937 1.653 0 1.099-.928 1.818-2.327 1.818zM29.8 17.061c0-.69-.5-1.203-1.178-1.203-.68 0-1.178.513-1.178 1.203 0 .691.499 1.204 1.178 1.204.675 0 1.178-.513 1.178-1.204zm1.824 0c0 1.639-1.15 2.807-2.76 2.807-.476 0-.911-.125-1.283-.349v2.07H25.79v-7.156h1.233l.227.418c.433-.374.99-.59 1.615-.59 1.61 0 2.76 1.163 2.76 2.8M35.185 18.236c.661 0 1.135-.48 1.135-1.174 0-.691-.474-1.175-1.135-1.175-.66 0-1.135.48-1.135 1.175 0 .695.474 1.174 1.135 1.174zm-2.95-1.175c0-1.63 1.234-2.8 2.95-2.8 1.71 0 2.95 1.17 2.95 2.8 0 1.625-1.24 2.801-2.95 2.801-1.716 0-2.95-1.176-2.95-2.8zM42.457 18.09v1.585H41.21c-1.164 0-1.872-.71-1.872-1.879v-1.984h-.963v-.423l2.358-2.508h.372v1.537h1.323v1.394H41.15v1.673c0 .377.228.604.61.604h.696zM45.315 19.862c-1.434 0-2.306-.756-2.323-1.895h1.745c0 .384.268.561.612.561.265 0 .516-.135.516-.407 0-.303-.398-.39-.904-.473-.816-.132-1.898-.378-1.898-1.653 0-1.054.9-1.734 2.248-1.734 1.34 0 2.209.712 2.23 1.777h-1.698c0-.335-.226-.492-.555-.492-.29 0-.485.144-.485.388 0 .299.402.369.902.458.831.147 1.937.32 1.937 1.653 0 1.099-.928 1.818-2.327 1.818z"
        fill="#2C2C2C"
      />
      <defs>
        <filter
          id="prefix__filter0_d_14648_26772"
          x={1.148}
          y={11.88}
          width={6.082}
          height={8.794}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_14648_26772" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_14648_26772" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_14648_26772"
          x={5.75}
          y={13.261}
          width={7.904}
          height={7.594}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_14648_26772" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_14648_26772" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d_14648_26772"
          x={12.82}
          y={13.261}
          width={7.835}
          height={9.328}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_14648_26772" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_14648_26772" result="shape" />
        </filter>
        <linearGradient
          id="prefix__paint0_linear_14648_26772"
          x1={10.731}
          y1={45.789}
          x2={29.717}
          y2={19.389}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6D6D6" />
          <stop offset={1} stopColor="#E8E8E8" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_14648_26772"
          x1={10.731}
          y1={7.964}
          x2={14.941}
          y2={-6.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6D6D6" />
          <stop offset={1} stopColor="#E8E8E8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default LogoAlt;
